import React, { Component } from 'react';
import { Col, Container } from 'reactstrap';
import Table from '../../tables/Table';
import RenderRow from './renderRow';
import RenderRowV2 from './renderRowV2'
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { signout } from '../../../redux/actions/userActions';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import { GetControls, GetControlStatus, GetControlBySectionID } from '../../../queries/controls'
import uuid from 'uuid';
import mockData from "../../../utils/mockData";

class ResponsiveTable extends Component {
  constructor(props) {
    super(props);

    this._isMounted = false;
  }

  state = {
    controls: [],
    users: [],
    status: [],
    loadingControls: true,
    loadingStatus: true,
    loadedControls: false,
    loadedStatus: false,
    hasMore: null,
    nextToken: null,
    selectedControl: null,
    scrolledToBottom: false,
    paginationLoaded: false
  }

  signoutUser () {
    this.props.signout();
    this.props.history.push('/');
  }

  componentDidMount () {
    try {
      this._isMounted = true
      if (this.props.frameworkId && this.props.category && this._isMounted) {
        if (!this.state.loadedControls) {
          this.getControls()
        }

        if (!this.state.loadedStatus) {
          //this.getControlStatus()
          this.getControlBySectionID()
        }
      }
    } catch (e) {
      if (e.networkError) {
        if (e.networkError['statusCode'] === 401) {
          this.signoutUser()
        }
      } else {
        console.log(e.message)
        this.signoutUser()
      }
    }
    window.addEventListener("scroll", this.handleOnScroll);
  }

  componentDidUpdate (prevProps, prevState) {
    try {
      if (prevProps.category !== this.props.category) {
        this.setState({
          loadedControls: false,
          loadedStatus: false,
          loadingControls: true,
          loadingStatus: true
        })
      }

      if ((prevProps.category !== this.props.category ||
        prevState !== this.state) &&
        this._isMounted) {

        if (!this.state.loadedControls) {
          this.getControls()
        }
      }

      if ((prevProps.category !== this.props.category ||
        prevState !== this.state) && this._isMounted) {
        if (!this.state.loadedStatus) {
          //this.getControlStatus()
          this.getControlBySectionID()
        }
      }
    } catch (e) {
      if (e.networkError) {
        if (e.networkError['statusCode'] === 401) {
          this.signoutUser()
        }
      } else {
        console.log(e.message)
        this.signoutUser()
      }
    }
  }

  componentWillUnmount () {
    window.removeEventListener("scroll", this.handleOnScroll);
    this._isMounted = false;
  }

  handleOnScroll = () => {
    var scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    var scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    var clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    var scrolledToBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (scrolledToBottom && this.state.hasMore) {
      this.setState({
        scrolledToBottom: true,
        paginationLoaded: false,
        loadingControls: true,
        loadingStatus: true,
        hasMore: null //prevents an extra fetchMore call, relying on the query to set this if there is more
      }, () => {
        this.fetchMore();
      })

    }
  };

  getControls = () => {
    try {
      const controlData = mockData.getTourControls();

      //console.log(controlData);

      if (controlData && controlData.controls && this._isMounted) {
        this.setState({
          controls: controlData.controls.items,
          loadedControls: true,
          loadingControls: false,
          nextToken: controlData.controls.nextToken,
          hasMore: controlData.controls.nextToken ? true : false,
          scrolledToBottom: false,
          paginationLoaded: true
        }, () => {
          try {
            const parsed = qs.parse(this.props.location.search.slice(1));
            if (parsed && parsed.controlId) {
              const id = String(parsed.controlId);
              const selectedControl = this.state.controls.find(c => c.controlID === id)

              if (selectedControl) {
                // this.getControlInView(selectedControl.controlID)
                this.setState({
                  selectedControl: selectedControl.controlID
                })
              }
            }
          } catch (err) {
          }
        });
      } else {
        this.setState({ loadedControls: true, loadingControl: false });
      }
    } catch (error) {
        console.log(error)
    }
  }

  fetchMore = async () => {
    try {
      const controlData = mockData.getTourControls();
      console.log(controlData);

      if (controlData && controlData.controls && this._isMounted) {
        this.setState({
          controls: [...this.state.controls, ...controlData.controls.items],
          loadedControls: true,
          loadingControls: false,
          nextToken: controlData.controls.nextToken,
          hasMore: controlData.controls.nextToken ? true : false,
          scrolledToBottom: false,
          paginationLoaded: true
        }, () => {
          const statusData = null;

          if (statusData && statusData.controlStatus && this._isMounted) {
            this.setState({
              status: [...statusData.controlStatus, ...this.state.status],
              loadedStatus: true,
              loadingStatus: false
            });
          }
        });
      } else {
        this.setState({
          loadedControls: true,
          loadingControl: false,
          loadedStatus: true,
          loadingStatus: false
        });
      }
    } catch (e) {
      console.log(e.message)
    }

  }

  getControlBySectionID = () => {
    try {
      if (this.state.controls && this.state.controls.length > 0) {
        const statusDataV2 = mockData.getTourControlBySectionID();
        
        if(statusDataV2 && statusDataV2.tasksBySectionId && this._isMounted){
          this.setState({
            status: statusDataV2.tasksBySectionId,
            loadedStatus: true,
            loadingStatus: false
          });
        }
        else{
          this.setState({ loadedStatus: true, loadingStatus: false });
        }
        /*if (statusDataV2 && statusDataV2.status && this._isMounted) {
          this.setState({
            status: statusDataV2.status,
            loadedStatus: true,
            loadingStatus: false
          });

        } else {
          this.setState({ loadedStatus: true, loadingStatus: false });
        }*/
      }
    } catch (error) {
      console.log(error)
    }
  }


  getControlStatus = () => {
    try {
      if (this.state.controls && this.state.controls.length > 0) {
        const statusData = null;

        if (statusData && statusData.controlStatus && this._isMounted) {
          this.setState({
            status: statusData.controlStatus,
            loadedStatus: true,
            loadingStatus: false
          });

        } else {
          this.setState({ loadedStatus: true, loadingStatus: false });
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  render () {
    const path = (this.props && this.props.location) ? this.props.location.pathname : ''
    return (
      <Container id="tour-compliance-control" style={{ paddingBottom: 0 }}>
        <Col md={12} lg={12}>
          {
            <Table
              responsive
              className={`table--bordered ${this.props.className}`}
              dataCategory={this.props.category}>
              <thead id="compliance_table">
                <tr id="tour-compliance-control">
                  <th style={{
                    width: 73
                  }} className="mobile-hide">ID</th>
                  <th className="adviceColumn"><span className="mobile-hide">Requirement</span>
                    <span className="mobile-show">ID/Requirement</span></th>
                  <th style={{
                    width: 150
                  }} ><span className="mobile-hide">Assigned To</span></th>
                  <th style={{
                    width: 140
                  }} className="mobile-hide" id="due-date-th">Due Date</th>
                  <th style={{
                    width: 170
                  }} className="mobile-hide">Status</th>
                  <th style={{
                    width: 120
                  }}></th>
                </tr>
              </thead>
              <tbody>
                {
                  // this.state.controls &&
                  //   this.state.controls.length > 0 &&
                  //   this.props.users.length > 0 &&
                  //   this.state.loadedStatus ?
                    renderControls(
                      this.state.controls.sort((a, b) => {
                        if (a && b) {
                          return Number(a.controlOrder) - Number(b.controlOrder)
                        }
                        else {
                          return null;
                        }
                      }),
                      this.props.title,
                      this.props.parse,
                      this.props.users,
                      this.props.frameworkId,
                      this.props.category,
                      path,
                      this.props.framework,
                      this.props.lowLevelCategory,
                      this.props.highLevelCategory,
                      this.props.isFlat,
                      this.state.status,
                      this.state.selectedControl,
                      this.props.handleStatusChange,
                      this.state.loadingControls,
                      this.state.loadingStatus,
                      this.props.humanHighLevelCategory.toLowerCase(),
                      this.props.layout)
                    //  : null
                }
              </tbody>
            </Table>
          }
          {
            !this.state.paginationLoaded || this.state.loadingStatus ?
              <div className={`custom_load loaded`}>
                <div className='load__icon-wrap' style={{ textAlign: 'center', margin: '30px auto' }}>
                  <svg className='load__icon'>
                    <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
                  </svg>
                </div>
              </div>
              : null
          }
        </Col>
      </Container>
    )
  }
}

const renderControls = (
  controls, page, parse,
  users, frameworkId, category,
  path, framework, lowLevelCategory,
  highLevelCategory, isFlat, status,
  selectedID, handleStatusChange, loadingControls, loadingStatus,
  humanHighLevelCategory, layout) => {

  return controls.map((control, i) => {
    const controlStatus = status.filter(_status => {
      return _status.controlId === control.controlNanoID
    });

    return (layout && layout === 2) ?
      <RenderRowV2
        lowLevelCategory={lowLevelCategory}
        highLevelCategory={highLevelCategory}
        humanHighLevelCategory={humanHighLevelCategory}
        framework={framework}
        path={path}
        category={category}
        id={control.controlID}
        index={i}
        control={control}
        page={page}
        key={/*control.referenceID*/uuid()}
        parse={parse}
        users={users}
        defaultValue={3}
        status={controlStatus.length === 0 ? null : controlStatus[0]}
        selected={control.controlID === selectedID ? true : false}
        handleStatusChange={handleStatusChange}
        loadingStatus={loadingStatus}
        loadingControls={loadingControls}
      /> :
      <RenderRow
        lowLevelCategory={lowLevelCategory}
        highLevelCategory={highLevelCategory}
        humanHighLevelCategory={humanHighLevelCategory}
        framework={framework}
        path={path}
        category={category}
        id={control.controlID}
        index={i}
        control={control}
        page={page}
        key={/*control.referenceID*/uuid()}
        parse={parse}
        users={users}
        defaultValue={3}
        status={controlStatus.length === 0 ? null : controlStatus[0]}
        selected={control.controlID === selectedID ? true : false}
        handleStatusChange={handleStatusChange}
        loadingStatus={loadingStatus}
        loadingControls={loadingControls}
      />
  })

}

ResponsiveTable.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.string,
  parse: PropTypes.bool.isRequired
};

function mapStateToProps (state) {
  return {
    user: state.auth.user,
    users: state.controlsData.users,
    dataLoaded: !state.controlsData.loading
  }
}

export default connect(mapStateToProps, { signout })(withRouter(withApollo(ResponsiveTable)));


// WEBPACK FOOTER //
// ./src/components/tour/compliance/control.js